import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { Observable, Subject } from 'rxjs';
import { PagingSort, TableCriteria, TableFilter } from './table.types';

@Injectable({
    providedIn: 'root'
})
export class TableStateService {
    constructor() {}
    private fromTableSubject = new Subject<TableState>();
    public fromTableResponse = this.fromTableSubject.asObservable();
    private toTableSubject = new Subject<TableState>();
    public toTable = this.toTableSubject.asObservable();
    private fromFilterSubject = new Subject<FilterState>();
    public fromFilter: Observable<FilterState> = this.fromFilterSubject.asObservable();
    private fromTableCriteria = new Subject<PagingSort>();
    public fromTableCriteriaResponse: Observable<PagingSort> = this.fromTableCriteria.asObservable();

    sendFromTable(state: TableState) {
        this.fromTableSubject.next(state);
    }

    sendToTable(state: TableState) {
        this.toTableSubject.next(state);
    }

    sendFilter(state: FilterState) {
        this.fromFilterSubject.next(state);
    }

    sendCriteria(pagingSort: PagingSort) {
        this.fromTableCriteria.next(pagingSort);
    }
}

export interface TableState {
    tableName: string;
    loading?: boolean;
    hasData?: boolean;
    element?: any;
    insert?: boolean;
    update?: boolean;
    remove?: boolean;
    notImmediateLoad?: boolean;
    updateSelect?: boolean;
    doneExporting?: boolean;
    doNotReloadDataOnDelete?: boolean;
    reloadData?: boolean;
}

export interface FilterState {
    tableName: string;
    filter: TableFilter;
    export?: boolean;
    exportConfig?: ExportConfiguration;
    filterStatementOutput?: string;
    pagingSort?: PagingSort;
}

export interface ExportConfiguration {
    exportId: string;
    dataName?: string;
    processingDataRows?: string;
    processingDataRowOf?: string;
}

export interface ExportConfigurationInput {
    dataName?: string;
    processingDataRows?: string;
    processingDataRowOf?: string;
}
